function submitSearchForm() {
  const userLocationLatitude = document.getElementById("user-location-latitude");
  const userLocationLongitude = document.getElementById("user-location-longitude");
}

function addEventListeners() {
  const locationBtn = document.getElementById("user-location-btn");
  if (locationBtn) {
    locationBtn.addEventListener("click", function() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          const userLocationLatitude = document.getElementById("user-location-latitude");
          const userLocationLongitude = document.getElementById("user-location-longitude");
          userLocationLatitude.value = latitude;
          userLocationLongitude.value = longitude;
          const searchForm = document.getElementById("search-form");
          searchForm.submit();
        });
      }
    });
  }

  const searchForm = document.getElementById("search-form");
  if (searchForm) {
    searchForm.addEventListener("submit", submitSearchForm);
  }
}

document.addEventListener("turbolinks:load", addEventListeners);

document.addEventListener("turbolinks:before-cache", function() {
  const locationBtn = document.getElementById("user-location-btn");
  if (locationBtn) {
    locationBtn.removeEventListener("click", function() {
      // Click event listener function
    });
  }

  const searchForm = document.getElementById("search-form");
  if (searchForm) {
    searchForm.removeEventListener("submit", submitSearchForm);
  }
});
